import { defineField, defineType } from 'sanity'
import { UnifiedPageBlockTypes, getBlockInsertMenuConfig } from '../pageBlocks'

export default defineType({
  title: 'Page Phase',
  name: 'pagePhase',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      description:
        'Not used on the page, only acts as label for the editor in Sanity Studio.',
    }),
    defineField({
      title: 'Start Date',
      name: 'startDate',
      type: 'datetime',
      options: {
        dateFormat: 'YYYY-MM-DD',
        timeFormat: 'HH:mm',
      },
      validation: (rule) => rule.required(),
    }),
    defineField({
      title: 'Page blocks',
      name: 'pageBlocks',
      type: 'array',
      of: UnifiedPageBlockTypes,
      options: {
        insertMenu: getBlockInsertMenuConfig(),
      },
    }),
  ],
  preview: {
    select: {
      title: 'title',
      startDate: 'startDate',
    },
    prepare({ title, startDate }) {
      return {
        title: title || 'Page Phase',
        subtitle: startDate
          ? `Starts: ${new Date(startDate).toLocaleDateString()}`
          : 'No start date',
      }
    },
  },
})
